import React from 'react';
import HeroSkeleton from './HeroSkeleton';
import EventNameSkeleton from './EventNameSkeleton';
import BuyTicketsCardSkeleton from './BuyTicketsCardSkeleton';
import DateAndTimeSkeleton from './DateAndTimeSkeleton';
import EventLocationSkeleton from './EventLocationSkeleton';
import EventDescriptionSkeleton from './EventDescriptionSkeleton';

const EventPageSkeleton = () => {
  return (
    <div>
      <HeroSkeleton />
      <div className="flex mt-4 md:mt-8">
        <div className="flex-1">
          <EventNameSkeleton />
          <DateAndTimeSkeleton />
          <EventLocationSkeleton />
          <hr className="my-[16px] md:my-[20px]" />
          <EventDescriptionSkeleton />
        </div>
        <BuyTicketsCardSkeleton />
      </div>
    </div>
  );
};

export default EventPageSkeleton;
